// Entegrasyonlar › Ödeme Entegrasyonları sekmesi (ödeme sağlayıcı listesi) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'integrations.payments';

export const paymentIntegrationsSectionGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Ödeme entegrasyonları nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'Kartla ödeme almak için kullandığınız sağlayıcıların (PayTR, Moka United, Tacreo Kart) mağaza bilgileri burada tutulur. Hangi kaydın aktif olduğu, hangi ödemenin hangi hesaba gideceğini belirler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Ödeme Entegrasyonu Ekle'),
    stats: t(`${G}.regions.stats`, 'Ödeme Sağlayıcı Entegrasyonları (kayıt sayısı)'),
    filters: t(`${G}.regions.filters`, 'Şube ve Sağlayıcı / Merchant ID arama'),
    toolbar: t(`${G}.regions.toolbar`, '⋮ İşlem menüsü'),
    table: t(`${G}.regions.table`, 'Entegrasyon listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfa başına'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Yeni sağlayıcı ekleyin'),
      text: t(`${G}.s1.text`, 'Sağ üstteki "Ödeme Entegrasyonu Ekle" düğmesi ekleme penceresini açar. Kayıt eklenince liste yenilenir ve "Kayıt başarıyla kaydedildi." mesajı çıkar.'),
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Şube ve şirket geneli kuralı'),
      text: t(`${G}.s2.text`, 'Bir sağlayıcı için şirket genelinde bir, her şubede de bir kayıt olabilir; aynısını ikinci kez ekleyemezsiniz. Ödeme alınırken önce işlemin yapıldığı şubenin aktif kaydı, yoksa şirket geneli aktif kayıt kullanılır.'),
      tips: [
        t(`${G}.s2.tip1`, 'E-ticaret sitenizdeki kartla ödeme yalnız şirket geneli (şube seçilmemiş) ve Aktif bir PayTR veya Moka kaydından alınır; şubeye bağlı kayıtlar sitede kullanılmaz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Durum etiketlerini okuyun'),
      text: t(`${G}.s3.text`, 'Tabloda Sağlayıcı, Şube ("Şirket Geneli" ya da şube adı), Merchant ID ve Durum sütunları vardır. Aktif / Pasif: pasif kayıt ödemelerde kullanılmaz. Test: kayıt sağlayıcının test ortamına bağlanır; canlı ödeme almadan önce kapatın. 3D: ödeme 3D Secure doğrulamasıyla yapılır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Dar ekranlarda liste tablo yerine kartlar halinde görünür; bilgiler aynıdır.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s4.title`, '4. Filtreleyin'),
      text: t(`${G}.s4.text`, 'Kayıt varsa üstte şube filtresi ve "Sağlayıcı / Merchant ID" arama kutusu çıkar. Şube filtresinde "Şirket Geneli" seçerseniz yalnız şubeye bağlı olmayan kayıtlar listelenir. Filtreler tüm sayfalara uygulanır ve liste ilk sayfaya döner.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. Düzenleyin veya silin'),
      text: t(`${G}.s5.text`, 'Satırdaki ⋮ menüsünde "Düzenle" kaydın bilgilerini değiştirme penceresini açar. "Sil" onay ister; silinen kayıt listeden kalkar ve ödemelerde artık kullanılmaz.'),
      tips: [
        t(`${G}.s5.tip1`, 'Ekranda silinen kaydı geri getiren bir düğme yoktur. Gerekirse aynı şube için sağlayıcıyı yeniden ekleyin.'),
        t(`${G}.s5.tip2`, 'Geçici olarak durdurmak için silmek yerine Düzenle\'den "Aktif" anahtarını kapatın.'),
      ],
    },
  ],
});
